module.exports = __webpack_public_path__ + "img/privacypolicy.212cbe85.png";